const DEVELOPER_PORTAL_URLS = Object.freeze({
  PRODUCTION: "https://prodeu2devportalapimgmtpeu2-xbco389jhy.eu2.hana.ondemand.com/",
  QUALITY: "https://prodeu2devportalapimgmtpeu2-u388hr22dq.eu2.hana.ondemand.com/",
  DEVELOPMENT: "https://prodeu2devportalapimgmtpeu2-ed119f165.eu2.hana.ondemand.com/",
});

const API_PORTAL_URLS = Object.freeze({
  PRODUCTION: "https://apiportal.schaeffler.com/",
  QUALITY: "https://apiportal-qas.schaeffler.com/",
  DEVELOPMENT: "https://apiportal-dev.schaeffler.com/",
});

export function getDeveloperPortalUrl(environment) {
  return DEVELOPER_PORTAL_URLS[environment] || "";
}

export function getSAPPortalUrl(environment, portal) {
  if (portal === "devportal") {
    return getDeveloperPortalUrl(environment);
  }
  if (portal === "apiportal") {
    return API_PORTAL_URLS[environment] || "";
  }
  return "";
}
